export default "<app-thumb-filtro [signal]=\"signal\" [type]=\"'details'\"></app-thumb-filtro>"